import { CancelToken } from 'axios'

import { DataReport } from 'Core/common/DataReport/types'
import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { Report } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (
	params: TableUrlParams
): Promise<{ items: Report.Basic[]; total: number }> =>
	Http.get(`${baseUrl}/report-logs`, { params })

export const downloadReport = (reportLogId: Key): Promise<Blob> =>
	Http.get(`${baseUrl}/${reportLogId}/download`, {
		responseType: 'blob'
	})

export const retrieveStatuses = (): Promise<Entity[]> => Http.get(`${baseUrl}/report-status`)

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<string[]> => Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })

export const retrieveReportNameOptions = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/report-names/options`)

export const retrieveReportData = (id: number): Promise<DataReport.Detailed> =>
	Http.get(`${baseUrl}/${id}`)

export const retrievePreviewOptions = (
	parameterId: Key,
	query?: string
): Promise<ValueDescription[]> =>
	Http.get(`parameters/${parameterId}/values`, { params: { query } })

export const generateReport = (id: Key, data: DataReport.Request): Promise<void> =>
	Http.post(`${baseUrl}/${id}/generate`, {
		...data,
		$type: 1
	})

export const generatePdfReport = (reportId: Key, invoiceId: number): Promise<Blob> =>
	Http.post(
		`${baseUrl}/${reportId}/generate`,
		{
			invoiceId,
			$type: 0
		},
		{
			responseType: 'blob'
		}
	)

export const generateEmailReport = (id: Key, data: DataReport.Request): Promise<void | string> =>
	Http.post(`${baseUrl}/${id}/send-to-email`, {
		...data,
		$type: 1
	})
